import React from "react";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/PersonalInfoCRUDConfig.json";
import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";

function PersonalInfoPage() {
  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
      <PageHeader pageTitle="Manage Personal Info" />
        <CrudManager
          data={schema}
          actionBtnName="Add Personal info"
          createFormTitle="Add Personal Info"
          updateFormTitle="Update Personal Info"
        />
      </Box>
    </Box>
  );
}

export default PersonalInfoPage;
